import { Link } from "react-router-dom";
import type { Post } from "../../lib/posts";
import { formatDate } from "../../lib/date";

type ArticleMetaProps = {
  post: Post;
};

export function ArticleMeta({ post }: ArticleMetaProps) {
  return (
    <div className="article-meta">
      <Link className="author-chip" to={post.authorUrl}>
        <img src={post.authorProfile.avatar} alt="" width="32" height="32" />
        <span>{post.authorProfile.name}</span>
      </Link>
      <span>
        Published <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
      </span>
      <span>
        Revised <time dateTime={post.updatedAt}>{formatDate(post.updatedAt)}</time>
      </span>
    </div>
  );
}
